var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.model.data,"border":"","span-method":_vm.spanMethod,"highlight-current-row":false}},_vm._l((_vm.model.rule),function(item,index){return _c('el-table-column',{key:index,attrs:{"prop":item.prop,"label":item.label,"width":item.width}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }